import httpService from '../request'

// 适用企业
export function reqTenantList (params) { return httpService({ url: '/tenant/simple/list', method: 'get', params }) }
// 所属子系统
export function reqStytemList (params) { return httpService({ url: '/application/page', method: 'get', params }) }

// 所属模块
export function reqMoKuai (appId) { return httpService({ url: `/menu/tree?appId=${appId}`, method: 'get' }) }
